import { EOutputType, ESelectionType } from "../../shared/sharedEnums";
import { IOwnershipFormData, ISectorFormData, ISelectedVesselsFormData, IVesselFormData } from "../../shared/sharedTypes";
import { IVesselSearchForm } from "./searchTypes";

export const filterGivenVesselsByFilterCriteriaForOutput = (
    vessels: IVesselSearchForm[],
    filterCriteria: { type: ESelectionType; value: string }
) => {
    const selectedVessels: IVesselFormData[] = vessels.filter((vessel) => {
        if (filterCriteria.type === ESelectionType.Sector) {
            return vessel.sector === filterCriteria.value;
        } else if (filterCriteria.type === ESelectionType.Ownership) {
            return vessel.companyName === filterCriteria.value;
        } else {
            throw new Error(`Unsupported filter type: ${filterCriteria.type}`);
        }
    }).map(
        (vessel) =>
            ({
                name: vessel.name,
                imoNumber: vessel.imoNumber,
                sectorName: vessel.sector,
                companyName: vessel.companyName,
            }) as IVesselFormData
    );

    const outputType =
        selectedVessels.length === 0
            ? EOutputType.None
            : selectedVessels.length === 1
                ? EOutputType.Vessel
                : selectedVessels.length < 201
                    ? EOutputType.Fleet
                    : EOutputType.Summary;

    const outputSelection: ISelectedVesselsFormData = {
        selectedVesselsList: selectedVessels,
        outputType: outputType,
        selectionType: filterCriteria.type,
        selectionName: filterCriteria.value,
        selectionTypeObject:
            filterCriteria.type === ESelectionType.Sector
                ? { name: filterCriteria.value } as ISectorFormData
                : { name: filterCriteria.value } as IOwnershipFormData,
    };

    return outputSelection;
};

export const createCleanOutputSelection = (vessels: IVesselSearchForm[]) => {
    return {
        selectedVesselsList: vessels.map((v) => ({
            name: v.name,
            imoNumber: v.imoNumber,
            sectorName: v.sector,
            companyName: v.companyName,
        })) as IVesselFormData[],
        outputType: vessels.length === 1 ? EOutputType.Vessel : vessels.length > 200 ? EOutputType.Summary : EOutputType.Fleet,
        selectionType: ESelectionType.None,
        selectionName: '',
    } as ISelectedVesselsFormData;
};